(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('subscription-package', {
                parent: 'entity',
                url: '/subscription-package?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.subscriptionPackage.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/subscription-package/subscription-packages.html',
                        controller: 'SubscriptionPackageController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('subscriptionPackageStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('subscription-package-detail', {
                parent: 'entity',
                url: '/subscription-package/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.subscriptionPackage.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/subscription-package/subscription-package-detail.html',
                        controller: 'SubscriptionPackageDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('subscriptionPackageStatus');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'SubscriptionPackage', function ($stateParams, SubscriptionPackage) {
                        return SubscriptionPackage.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('subscription-package.new', {
                parent: 'subscription-package',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/subscription-package/subscription-package-dialog.html',
                        controller: 'SubscriptionPackageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    description: null,
                                    durationDays: null,
                                    chargeFee: null,
                                    startDate: null,
                                    endDate: null,
                                    status: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('subscription-package', null, {reload: true});
                    }, function () {
                        $state.go('subscription-package');
                    });
                }]
            })
            .state('subscription-package.edit', {
                parent: 'subscription-package',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/subscription-package/subscription-package-dialog.html',
                        controller: 'SubscriptionPackageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['SubscriptionPackage', function (SubscriptionPackage) {
                                return SubscriptionPackage.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('subscription-package', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('subscription-package.delete', {
                parent: 'subscription-package',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/subscription-package/subscription-package-delete-dialog.html',
                        controller: 'SubscriptionPackageDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['SubscriptionPackage', function (SubscriptionPackage) {
                                return SubscriptionPackage.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('subscription-package', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
